<template>
  <div id="app" class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
  @import "sass/main"
</style>




// WEBPACK FOOTER //
// App.vue?1c3d1a64